import { useContext} from 'react';
import axios from 'axios'
import AuthContext  from './AuthContext'
import { getInLocalStorage, setInLocalStorage } from './utils/localStorage';
import { useToast } from './toastHook'
import { HubConnectionBuilder} from '@microsoft/signalr' 
import ToastConnectionContext from './ToastConnectionContext';
import moment from 'moment';

export const isUserAuthentificated = user => user && user.bearerToken && user.expirationDate && moment(user.expirationDate).utc() > moment.utc();

export const useAuthUser = () => {
    const { authUser, setAuthUser } = useContext(AuthContext);
    const {signalRConnection, setSignalRConnection} = useContext(ToastConnectionContext);
    const { display } = useToast();

    const connectAndSetInUserStorage = user => {
        setAuthUser(user);
        setInLocalStorage('auth', user);

        let token = user.bearerToken;

        axios.interceptors.request.use(config => {
            config.headers = { 'Authorization': 'Bearer ' + token }
            return config;
        });

        connectSignalRToast(user);
    }

    const connectSignalRToast = user => {

        if (!isUserAuthentificated(user)) {
            return;
        }
        if (signalRConnection) {
            disconnectSignalRToast();
        }

        const sConnection = new HubConnectionBuilder()
            .withUrl('/api/toast', { accessTokenFactory: () => user.bearerToken })
            .withAutomaticReconnect()
            .build();

        sConnection.start()
            .then(r => console.log("connect to server toast"))
            .catch(e => {
                console.log("unable to connect to server toast")
                display({
                    titre: 'Impossible de se connecter',
                    text: 'la connection à la messagerie interne a échouée, veuillez réessayer',
                    severity: 'danger'
                })
            })

        sConnection.on('display', message => {
            display(message)
        });

        setSignalRConnection(sConnection);
    }

    const disconnectSignalRToast =  () =>
    {
        if (signalRConnection) {
            signalRConnection.stop()
                .then(r => console.log("disconnected from server toast"))
            .catch("unable to disconnect from server toast")

            setSignalRConnection(undefined);
        }
    }

    const init = () => {

        axios.interceptors.response.use(response => response, error => {
            if (error.response.status === 401) {
                logout();
            }
            else if (error.response.status === 403) {
                display({
                    severity: 'danger',
                    text: "Vous n'êtes pas autorisé à effectuer cette action",
                    titre: 'non autorisé'
                })
            }
            else {
                display({
                    severity: 'danger',
                    text: 'une erreur a eu lieu, veuillez réessayer',
                    titre: 'erreur'
                });
            }

            return error;
        })

        let authInLocalStorage = getInLocalStorage('auth');

        if (isUserAuthentificated(authInLocalStorage)) {
            connectAndSetInUserStorage(authInLocalStorage);
        }
    }

    const login = (UserName, Password) => {

        return axios.post("/api/auth/signin", { UserName, Password })
            .then(response => {
                if (response.data.bearerToken) {
                    connectAndSetInUserStorage(response.data);

                    return true;
                }
                else {
                    return false;
                }
            });
    }

    const isAuthentificated = () => { 
        return isUserAuthentificated(authUser);
    }

    const getUserName = () => {

        if (!isAuthentificated()) {
            return "";
        }

        return authUser.userName;
    }


    const logout = () => {
        setAuthUser(null);
        localStorage.removeItem('auth');
        axios.interceptors.request.clear();
        disconnectSignalRToast();
    }

    const checkRole = role => {
        if (!isAuthentificated() ) {
            return false;
        }

        return authUser.claims.filter(x => x.value === role).length > 0;
    }

    return { login , logout, getUserName, isAuthentificated, init, checkRole }
}























